import $ from 'jquery';
import 'slick';
import 'magnific-popup/dist/jquery.magnific-popup';
import { 
    slickCommonOptions 
} from '../../scripts/config';

/**
 * GalleryV1 widget configs
 */
const galleryV1Semantics = {
    'mainWrapClass': 'gallery-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'commonPluginOptionsAttribute': 'data-common-plugin-options',
    'controlPrevClass': 'gallery-v1__prev',
    'controlNextClass': 'gallery-v1__next',
    'sliderElementClass': 'gallery-v1__track',
    'trackElement': 'gallery-v1__track-element',
    'activeClass': 'gallery-v1__track-element_active',
    'sliderCurrentImage': 'gallery-v1__slick-linker',
    'slideElement': 'slick-slide',
    'slideTrack': 'slick-track',
    'slideCurrent': 'slick-current',
    'popupClassImage': 'gallery-v1__img-preview',
    'popupMainClass': 'gallery-v1__popup',
};

/**
 * GalleryV1 initializer
 */
$(function () {

    if ($(`.${galleryV1Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    window.widgets.galleryV1 = new GalleryV1();

    /**
     * Checking other instances
     */

    $(`.${galleryV1Semantics.mainWrapClass}`).each((index, el) => {
        let objectElement = $(el);
        let isInitialized =
            ($(el).attr(`${galleryV1Semantics.isInitializedAttribute}`) === 'true');
        if (!isInitialized) {
            window.widgets.galleryV1.registerInstance(objectElement);
            window.widgets.galleryV1.registerPopupOpen(objectElement);
            window.widgets.galleryV1.registerScrollEvent(objectElement);
            window.widgets.galleryV1.registerCustomSlickEvent(objectElement);
        }
    });

});

class GalleryV1 {
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${galleryV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        let commonPluginOptions =
            el.data(
                `${galleryV1Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};

        let sliderCurrentImageClass = `.${galleryV1Semantics.mainWrapClass}` +
            `[${galleryV1Semantics.instanceIdAttribute}="` +
            el.attr(`${galleryV1Semantics.instanceIdAttribute}`) +
            `"] .${galleryV1Semantics.sliderCurrentImage}`;

        let mainSliderClass = `.${galleryV1Semantics.mainWrapClass}` +
            `[${galleryV1Semantics.instanceIdAttribute}="` +
            el.attr(`${galleryV1Semantics.instanceIdAttribute}`) +
            `"] .${galleryV1Semantics.sliderElementClass}`;

        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: true,
                vertical: true,
                draggable: true,
                slidesPerRow: 1,
                slidesToShow: 5,
                slidesToScroll: 1,
                focusOnSelect: true,
                asNavFor: sliderCurrentImageClass,
                prevArrow: `.${galleryV1Semantics.mainWrapClass}` +
                    `[${galleryV1Semantics.instanceIdAttribute}="` +
                    el.attr(`${galleryV1Semantics.instanceIdAttribute}`) +
                    `"] .${galleryV1Semantics.controlPrevClass}`,
                nextArrow: `.${galleryV1Semantics.mainWrapClass}` +
                    `[${galleryV1Semantics.instanceIdAttribute}="` +
                    el.attr(`${galleryV1Semantics.instanceIdAttribute}`) +
                    `"] .${galleryV1Semantics.controlNextClass}`,
            }
        );

        let pluginOptionLinked = {
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: mainSliderClass,
            dots: false,
            arrows: false,
        }

        el.show();
        try {
            // TODO[dependDetected]: slick plugin
            let slick = $(mainSliderClass).slick(pluginOptions);
            $(sliderCurrentImageClass).slick(pluginOptionLinked);

            el.attr(`${galleryV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = slick;

        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerScrollEvent(el) {
        let sliderElement = el.find(
            `.${galleryV1Semantics.sliderElementClass}`
        );
        let sliderTrack = sliderElement.find(
            `.${galleryV1Semantics.slideTrack}`
        );
        sliderTrack.on('mousewheel DOMMouseScroll', function (e) {
            e.preventDefault();
            if (e.originalEvent.wheelDelta > 0 || e.originalEvent.detail < 0) {
                sliderElement.slick('slickPrev')
            } else {
                sliderElement.slick('slickNext')
            }
            /*  sliderTrack.slick('setPosition');
              sliderTrack.slick('refresh');*/
        });
    }

    registerCustomSlickEvent(el) {
        let sliderElement = el.find(
            `.${galleryV1Semantics.sliderElementClass}`
        );

        sliderElement.on('afterChange', function (event, slick, currentSlide) {
            window.widgets.galleryV1.setActiveSlide(el)

        });
    }

    setActiveSlide(el) {
        let currentObject = el.find(`.${galleryV1Semantics.slideCurrent}`);
        currentObject.find(`.${galleryV1Semantics.trackElement}`)
            .addClass(galleryV1Semantics.activeClass)

        currentObject.siblings().each(function () {
            $(this).find(`.${galleryV1Semantics.trackElement}`)
                .removeClass(galleryV1Semantics.activeClass)
        });
    }

    registerPopupOpen(el) {
        let imagePopup = el.find(`.${galleryV1Semantics.sliderCurrentImage}`);
        if (imagePopup.length) {
            imagePopup.magnificPopup({
                mainClass: galleryV1Semantics.popupMainClass,
                delegate: 'a',
                type: 'image',
                image: {
                    verticalFit: true
                },
                gallery: {
                    enabled: true,
                    tCounter: '%curr% из %total%'
                },
            });
        }
    }

    reInit(instanceId) {
        window.widgets.galleryV1.pluginInstances[instanceId].slick('unslick').slick('init');
    }
}